import React from 'react'
// import _ from 'lodash'
import { Card, CardImg, CardHeader, CardText, CardFooter } from 'reactstrap' // CardBody is missing......
// import { Card, CardImg, CardHeader, CardText, CardBody } from 'reactstrap'
// CardBody is missing......
import { withRouter } from 'react-router'

// import FontAwesome from 'react-fontawesome'
// import { Link } from 'react-router-dom'
import dateFormat from 'dateformat'


// console.log('dumping CardBody', CardBody);


class RecipeListItem extends React.Component {
	goToEdit = () => {
		this.props.history.push(`/recipe/${this.props.item.recipeID}`)
	}

	// ********************************************************************************
	// ********************************************************************************

	render() {
		const imgBase = '/assets/recipes/large'
		const theThumbSrc = (this.props.item.filename !== '' && this.props.item.filename !== null)
			? `${imgBase}/${this.props.item.filename}`
			: `${imgBase}/no-image.jpg`
		const lastUpdated = (this.props.item.lastUpdated !== null)
			? dateFormat(this.props.item.lastUpdated, 'mm/dd/yyyy')
			: 'N/A'
		// const totalTime = (props.item.timePrep + props.item.timeCook + props.item.timeReady)

		// console.log('props.item > ', props.item);

		return (
			<Card
				color="primary"
				className="text-center h-100"
				onClick={this.goToEdit}
				style={{
					cursor: 'pointer'
				}}
			>
				<CardHeader>{this.props.item.recipe}</CardHeader>
				<CardImg top width="100%" src={theThumbSrc} alt="" />
				<div className="card-body">
					<CardText>a short description will go in this spot and look nice</CardText>
					{/*
					<CardText>
						<Badge>{_.size(props.item.recipeIngredients)}</Badge> ingredients<br />
						<FontAwesome name="clock-o" />{' Prep '}{props.item.timePrep}<br />
						<FontAwesome name="hourglass-o" />{' Cook '}{props.item.timeCook}<br />
						<FontAwesome name="check" />{' Ready '}{props.item.timeReady}<br />
						<FontAwesome name="smile-o" />{' Total Time '}{totalTime}<br />
						<br />
						<FontAwesome name="cutlery" />{' Serves '}{props.item.serves}<br />
					</CardText>
					*/}
				</div>
				<CardFooter>
					<small>
						Last updated
						{' '}
						{lastUpdated}
					</small>
				</CardFooter>
			</Card>
		)
	}
}

export default withRouter(RecipeListItem)



// WEBPACK FOOTER //
// ./src/modules/list/item.jsx